import styled, { withTheme } from 'styled-components';
import BaseDataCard from './base-data-card';

const PortfolioListCard = styled(BaseDataCard)`
    & > .card-block {
    }
`;

export default withTheme(PortfolioListCard);
